import nl from 'date-fns/locale/nl'
import enGB from 'date-fns/locale/en-GB'
import el from 'date-fns/locale/el'
// couple to i18n fallback

export default { nl, en: enGB, el }; // must be under i18n locales namespace
